import { render } from "./SpeciaList.vue?vue&type=template&id=0d566581&scoped=true"
import script from "./SpeciaList.vue?vue&type=script&lang=js"
export * from "./SpeciaList.vue?vue&type=script&lang=js"

import "./SpeciaList.vue?vue&type=style&index=0&id=0d566581&lang=scss&scoped=true"

import exportComponent from "D:\\Code\\word\\anyRTC\\anyrtc_synergy\\Synergy-Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d566581"]])

export default __exports__